import {Component, ElementRef, HostListener, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import {Maintenance} from '../../../models/maintenance.model';
import {Machine} from '../../../models/machine.model';
import {MachinesService} from '../../../services/machines.service';
import {MachineMaintenanceService} from '../../../services/machine.maintenance.service';
import {MachineMaintenance} from '../../../models/machine.maintenance.model';

@Component({
  providers: [MachinesService, MachineMaintenanceService],
  selector: 'app-machines-history',
  templateUrl: './machine.history.component.html',
})
export class MachinerHistoryComponent implements OnDestroy, OnInit {
  public machine: Machine;
  public maintenances: MachineMaintenance[];

  private _selectedMaintenance: MachineMaintenance;
  private _ngUnSubscribe: Subject<void> = new Subject<void>();

  constructor(private _route: ActivatedRoute, private _machineService: MachinesService,
              private _machineMaintenanceService: MachineMaintenanceService,
              private _elementReference: ElementRef,  public router: Router) {}

  public ngOnInit() {
    this._route.params
      .takeUntil(this._ngUnSubscribe)
      .subscribe(params => {
        const machineId = params['id'];

        if (machineId) {
          this._machineService.load(machineId);
          this._machineService.machines$
            .takeUntil(this._ngUnSubscribe)
            .subscribe(
              machines => {
                this.machine = machines.find(pr => pr._id === machineId);
              }
            );

          this._machineMaintenanceService.loadMachineHistory(machineId);
          this._machineMaintenanceService.maintenances$
            .takeUntil(this._ngUnSubscribe)
            .subscribe(
              maintenances => {
                this.maintenances = maintenances;
              }
            );
        }
      });
  }

  public ngOnDestroy() {
    this._ngUnSubscribe.next();
    this._ngUnSubscribe.complete();
  }

  set selectedMaintenance(value: MachineMaintenance) {
    this._selectedMaintenance = value;
    this.detailsMaintenance();
  }
  get selectedMaintenance(): MachineMaintenance {
    return this._selectedMaintenance;
  }

  public detailsMaintenance(): void {
    if (this.selectedMaintenance) {
      this.router.navigate(['/maintenances', this.selectedMaintenance.maintenance._id]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/machine/history/machine.history.component.ts